import { HStack, Text } from '@talos/kyoko';
import styled from 'styled-components';

interface LegendItem {
  symbol: string;
  value: string;
  color: string;
  /** Undefined when no directional data is available (e.g. zero anchor in absolute mode). */
  isPositive: boolean | undefined;
}

interface ComparisonLegendProps {
  items: LegendItem[];
}

export function ComparisonLegend({ items }: ComparisonLegendProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <LegendRow data-testid="comparison-legend">
      {items.map(item => (
        <LegendChip key={item.symbol} data-testid="comparison-legend-item">
          <ColorDot $color={item.color} />
          <Text size="fontSizeSmall">{item.symbol}</Text>
          <Text
            size="fontSizeSmall"
            color={
              item.isPositive === undefined ? undefined : item.isPositive ? 'colorTextPositive' : 'colorTextNegative'
            }
          >
            {item.value}
          </Text>
        </LegendChip>
      ))}
    </LegendRow>
  );
}

const LegendRow = styled(HStack)`
  position: absolute;
  top: ${({ theme }) => theme.spacing16}px;
  left: ${({ theme }) => theme.spacing8}px;
  z-index: 1;
  gap: ${({ theme }) => theme.spacing8}px;
  pointer-events: none;
`;

const LegendChip = styled(HStack)`
  gap: ${({ theme }) => theme.spacing4}px;
  padding: ${({ theme }) => theme.spacing2}px ${({ theme }) => theme.spacing4}px;
  background: ${({ theme }) => theme.backgroundDropdown};
  border: 1px solid ${({ theme }) => theme.borderColorPopover};
  border-radius: ${({ theme }) => theme.borderRadiusDefault}px;
`;

const ColorDot = styled.span<{ $color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;
`;
